import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
export const MediaKindSchema = z.enum(['image', 'video']);
export const MediaAssetStatusSchema = z.enum(['pending', 'processing', 'ready', 'failed']);
export const CreateMediaAssetRequestSchema = z.object({
    kind: MediaKindSchema,
    originalFilename: z.string().min(1).max(300),
    contentType: z.string().min(1),
});
export const CreateMediaAssetResponseSchema = z.object({
    assetId: z.string().min(1),
    uploadUrl: z.string().url(),
    objectKey: z.string().min(1),
});
/** Client confirms the upload finished. Asset moves to `processing`; the worker
 *  verifies metadata (ffprobe), builds a thumbnail, and for videos ensures a
 *  browser-safe H.264 `playback` variant before marking `ready` (or `failed`). */
export const CompleteMediaAssetRequestSchema = z.object({
    checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
    byteSize: z.number().int().positive(),
    durationSeconds: z.number().positive().optional(),
});
/** Operator rename from the Library lightbox. The storage object key is unchanged. */
export const UpdateMediaAssetRequestSchema = z.object({
    originalFilename: z.string().trim().min(1).max(300),
});
export const MediaAssetSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    kind: MediaKindSchema,
    originalFilename: z.string().min(1),
    objectKey: z.string().min(1),
    contentType: z.string().min(1),
    byteSize: z.number().int().nonnegative().nullable(),
    durationSeconds: z.number().nonnegative().nullable(),
    checksumSha256: z.string().nullable(),
    status: MediaAssetStatusSchema,
    /** When the asset row was created (upload start). */
    createdAt: IsoDateTimeSchema,
    /** Short-lived signed URL for library thumbnails / image preview. Null when not ready. */
    previewUrl: z.string().url().nullable().optional(),
    /**
     * Videos: short-lived signed URL for the H.264 `playback` variant (dashboard
     * lightbox / Manage preview). Null until optimize finishes. Never the JPEG poster.
     */
    playbackUrl: z.string().url().nullable().optional(),
    /**
     * Videos: true once a browser-safe H.264 `playback` variant exists.
     * Images: true when status is ready. Omitted/false while still optimizing.
     */
    playbackReady: z.boolean().optional(),
    /** True when a media.normalize job is pending/processing for this asset. */
    optimizeQueued: z.boolean().optional(),
});
//# sourceMappingURL=media.js.map